module.exports = __webpack_public_path__ + "img/icon_go.51352f62.svg";